import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-collapse',
  templateUrl: './ui-collapse.component.html',
  styleUrls: ['./ui-collapse.component.scss']
})
export class UiCollapseComponent implements OnInit {
  isCollapsed = true;
  isCollapsed1 = true;
  isCollapsed2 = true;
  isCollapsed3 = true;
  constructor() { }

  ngOnInit(): void {
  }

}
